import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import { AlertInfo } from "src/@/components/shared/AlertInfo";

const CardFinishChat = ({
  user,
  changeBlock,
  block,
 }) => {
  const { t } = useTranslation('automation');

  return (
    <div className="w-full">
        <div className="space-y-4">
          {/* Seleção de Usuário */}
          <div>
            <AlertInfo
                title={t('reactionCards.finishChat.title', 'Finalizar Chat')}
                description={t('reactionCards.finishChat.description', 'Se houver um chat vinculado, ele será finalizado.')}
            />
          </div>
        </div>
    </div>
  );
};

export default CardFinishChat;
